import { TERRITORY_PAGE_PATH } from '../constants.ts';

export const BLACKLISTED_SELECT_HEADER_PATH = [TERRITORY_PAGE_PATH];
